import React from 'react';
import PropTypes from 'prop-types';

import CustomizePaymentTarget from 'payment-calculator/components/PaymentCalculatorDetails/components/CustomizePayment/CustomizePaymentTarget.jsx';
import TaxesIncluded from 'payment-calculator/components/TaxesIncluded/TaxesIncluded.jsx';

import { PurchaseMethods, ModelYear } from '@sm360/widget-commons-vehicle';

import 'payment-calculator/components/PaymentCalculatorDetails/components/CustomizePayment/customizePayment.scss';

const CustomizePayment = ({ purchaseMethods, updateTargetPayment, selectPaymentFrequency, modelYear }) => {
    return (
        <section className="new-customize-payment">
            <CustomizePaymentTarget
                purchaseMethods={purchaseMethods}
                onTargetPaymentSlide={updateTargetPayment}
                onPaymentFrequencyClick={selectPaymentFrequency}
                modelYear={modelYear}
            />
            <TaxesIncluded purchaseMethods={purchaseMethods} />
        </section>
    );
};

CustomizePayment.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethods.PurchaseMethodsModel).isRequired,
    modelYear: PropTypes.instanceOf(ModelYear.ModelYearModel).isRequired,
    updateTargetPayment: PropTypes.func.isRequired,
    selectPaymentFrequency: PropTypes.func.isRequired,
};

CustomizePayment.displayName = 'CustomizePayment';

export default CustomizePayment;
